import { Injectable } from '@angular/core';
import { UserFormPermissions } from '../models/permissions.model';
import { FormShareService } from './share.service';
import { UserContextService } from '../../user/services/user-context.service';
import {formStatus, formTypes, getEditableFormStatuses} from 'app/form/form.constants';
import { signableFormStatuses, editableFormStatuses } from '../form.constants';
import {userType} from '../../user/user.constants';

@Injectable()
export class FormPermissionService {
  constructor(
    private shareService: FormShareService,
    private userContext: UserContextService
  ) {}

  updatePermissions() {
    // When updating permissions, we need to take care to preserve the first reference of the permission object

    if (this.shareService.permissions) {
      // All subsequent assignments to the permission property go to this block
      Object.assign(this.shareService.permissions, this.getPermissions());
    } else {
      // This is for very first assignment
      this.shareService.permissions = this.getPermissions();
    }
  }

  private getPermissions(): UserFormPermissions {
    const form = this.shareService.form;
    const currentFormStatus = form.currentFormStatus;

    const permissions = <UserFormPermissions>{};
    permissions.canUserEdit =
      !this.userContext.isUserGuest() &&
      getEditableFormStatuses(
        this.userContext.currentUser.userType,
        this.shareService.form.type
      ).includes(currentFormStatus);
    if (
        this.userContext && this.userContext.currentUser && this.userContext.currentUser.userType === userType.management.code &&
        this.shareService.form && this.shareService.form.type === formTypes.coo.abbrev &&
        currentFormStatus === formStatus.pending
      ) {
      permissions.canUserEdit = false;
    }
    if (
        this.userContext && this.userContext.currentUser &&
        this.userContext.currentUser.userType === userType.management.code &&
        this.shareService.form &&
        [
          formTypes.rdLqre.abbrev,
          formTypes.rdLqre100.abbrev,
          formTypes.rdIncreaseInRD.abbrev,
          formTypes.rdSbir.abbrev
        ].includes(this.shareService.form.type)
      ) {
      permissions.canUserEdit = false;
    }
    permissions.canUserEditProjectInfo =
      permissions.canUserEdit && this.userContext.currentUser.userType !== 'manager' &&
      [formTypes.advance.abbrev, formTypes.application.abbrev].includes(
        form.type
      );
    permissions.canUserSign =
      signableFormStatuses(
        this.userContext.currentUser.userType,
        this.shareService.form.type
      ).includes(currentFormStatus) && this.shareService.isUserSignee();
    permissions.canUserViewSignature =
      (permissions.canUserSign &&
        signableFormStatuses(
          this.userContext.currentUser.userType,
          this.shareService.form.type
        ).includes(currentFormStatus)) ||
      (!permissions.canUserSign &&
        !signableFormStatuses(
          this.userContext.currentUser.userType,
          this.shareService.form.type
        ).includes(currentFormStatus));
    return permissions;
  }
}
